import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, ValidationErrors, Validator } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CheckboxComponent } from '../checkbox/checkbox.component';

@Component({
    selector: 'v-checkboxes',
    templateUrl: './checkboxes.component.html',
    styleUrls: ['./checkboxes.component.scss']
})
export class CheckboxesComponent implements ControlValueAccessor, Validator, OnDestroy {

    @Input() value: boolean = false;
    @Input() required: boolean;
    @Input() info: string;

    @Output() onChanged = new EventEmitter<any[]>();

    private cachedChanges: any[];
    private checkboxes: CheckboxComponent[] = [];
    private subscriptions = new Subscription();

    constructor() { }

    ngOnDestroy(): void {
        this.subscriptions?.unsubscribe();
    }

    triggerChanges(): void {
        this.emitChanges();
    }

    registerCheckbox(checkboxComponent: CheckboxComponent): void {
        if (this.checkboxes.indexOf(checkboxComponent) > -1) {
            return;
        }

        this.checkboxes.push(checkboxComponent);
    }

    unregisterCheckbox(checkboxComponent: CheckboxComponent): void {
        const indexOfCheckbox = this.checkboxes.indexOf(checkboxComponent);

        if (indexOfCheckbox === -1) {
            return;
        }

        this.checkboxes.splice(indexOfCheckbox, 1);
    }

    // ---

    private emitChanges(): void {
        const checkedValues: any[] = [];

        this.checkboxes.forEach(checkbox => {
            if (!checkbox.checked) {
                return;
            }

            checkedValues.push(checkbox.value);
        });

        if (JSON.stringify(checkedValues) == JSON.stringify(this.cachedChanges)) {
            return;
        }

        this.cachedChanges = checkedValues;

        this.onChanged.emit(checkedValues);
    }

    // --- Validator

    validate(control: AbstractControl): ValidationErrors {
        return null;
    }

    registerOnValidatorChange?(fn: () => void): void {

    }

    // --- ControlValueAccessor

    writeValue(obj: any): void {

    }

    registerOnChange(fn: any): void {

    }

    registerOnTouched(fn: any): void {

    }

    setDisabledState?(isDisabled: boolean): void {

    }
}
